import React from 'react';
import { TablePagination, Table } from '@material-ui/core';
import { useHistory } from 'react-router';
import TableContent from './TableContent';
import TableHeader from './TableHeader';
import { openInNewTab } from '../../helpers';

const HealtheraTable = ({
  data,
  totalCount,
  page,
  displayPagination,
  rowsPerPage,
  rowsPerPageOptions,
  onChangePage,
  onRowsPerPageChange,
  isLiveDashboard,
  group = false,
  groupBy = '_id',
  groupTitle = '_id',
  renderGroupItem = null,
  groupActionField = '',
  groupActionIndex = 0,
  noHover = false,
  onRowClick,
}) => {
  const history = useHistory();

  const [firstElementWithHeaders] = data.filter(item => item.headers);

  const headers =
    firstElementWithHeaders &&
    Object.keys(firstElementWithHeaders.view).map(headerKey => {
      const headerValue = firstElementWithHeaders.view[headerKey];
      const header = {
        title: headerValue,
        key: headerKey,
        width: 'auto'
      };

      if (headerValue.title) {
        const { title, width } = headerValue;
        header.title = title;
        if (width) header.width = width;
      }

      return header;
    });

  const rows = data
    .filter(item => !item.headers)
    .map(row => ({
      ...row.view,
      ID: row.ID,
      route: row.route,
      button: row.button,
      skipId: row.skipId,
      onClick: row.onClick
    }));

  const buttonTitle = rows?.length !== 0 && rows[0]?.button?.title;

  const handleRowClick = (route, ID, skipId = false, rowData) => {
    if (onRowClick) {
      onRowClick(rowData);
      return;
    }
    
    if (!ID && !skipId) {
      return;
    }
    const path = skipId
      ? `${process.env.PUBLIC_URL}/${route}`
      : `${process.env.PUBLIC_URL}/${route}/${ID}`;

    const { pathname, search, state } = history.location;
    const goBackLinks = [...(state?.goBackLinks || []), pathname + search];

    history.push(path, { goBackLinks });
  };

  const handleRowMiddleClick = (route, ID, skipId = false) => {
    if (!ID && !skipId) {
      return;
    }

    const path = skipId
      ? `${process.env.PUBLIC_URL}/${route}`
      : `${process.env.PUBLIC_URL}/${route}/${ID}`;

    /*
      Gets full path to a new page.

      Example:
        current page: https://domainname.com/anything/else
        cut's off https://domainname.com/ (splits by slashes and slices 3 elems)
        adds new relative path https://domainname.com/new/path
    */
    const fullPath =
      window.location.href
        .split('/')
        .slice(0, 3)
        .join('/') + path;

    openInNewTab(fullPath);
  };

  return (
    <>
      <Table style={styles.table}>
        <TableHeader buttonTitle={buttonTitle} headers={headers} />
        <TableContent
          rows={rows}
          headers={headers}
          onClick={handleRowClick}
          onMiddleClick={handleRowMiddleClick}
          isLiveDashboard={isLiveDashboard}
          group={group}
          groupBy={groupBy}
          groupTitle={groupTitle}
          renderGroupItem={renderGroupItem}
          groupActionField={groupActionField}
          groupActionIndex={groupActionIndex}
          noHover={noHover}
        />
      </Table>
      {displayPagination && rows.length !== 0 && (
        <TablePagination
          component="div"
          count={Number(totalCount)}
          rowsPerPage={rowsPerPage}
          page={page}
          rowsPerPageOptions={rowsPerPageOptions}
          backIconButtonProps={{ 'aria-label': 'Previous Page' }}
          nextIconButtonProps={{ 'aria-label': 'Next Page' }}
          onChangePage={onChangePage}
          labelRowsPerPage="Results per page: "
          onChangeRowsPerPage={onRowsPerPageChange}
        />
      )}
    </>
  );
};

export const styles = {
  table: {
    tableLayout: 'fixed'
  },
  cell: {
    padding: '0 5px',
  }
};

export default HealtheraTable;
